import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { decorateIntlMessages } from '../rosetta_formatted_message';
import SocialIcon from '../social_icon';
import PropTypes from 'prop-types';
import { stringify } from 'querystring';

const BASE_URL = 'https://share.flipboard.com/bookmarklet/popout?';

export const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  paidHashtag: {
    id: 'paid_hashtag',
    description:
      'Translation for "#paid" in social share URLs for sponsored stories',
    defaultMessage: '#paid'
  },
  share_button_title: {
    id: 'share_button_title',
    description: 'Share button title attribute content (Share on Flipboard)',
    defaultMessage: 'Share on Flipboard'
  }
}));

const getHashtag = ({ enableAdTextForShares, intl }) =>
  enableAdTextForShares
    ? ` ${intl.formatMessage(i18nMessages.paidHashtag)}`
    : '';

export const FlipboardSocialIcon = ({ sanitizedTitle, url_full, ...props }) => (
  <SocialIcon
    url_full={url_full}
    category="Flipboard"
    action="Share"
    faClassName="flipboard"
    socialURL={BASE_URL + stringify({
      v: 2,
      title: `${sanitizedTitle} ${getHashtag(props)}`,
      url: url_full,
      utm_source: 'flipboard',
      utm_medium: 'article-share',
      utm_campaign: 'publisher'
    })}
    title={props.intl.formatMessage(i18nMessages.share_button_title)}
    parentClass={props.parentClass}
  />
);

FlipboardSocialIcon.propTypes = {
  sanitizedTitle: PropTypes.string.isRequired,
  url_full: PropTypes.string.isRequired,
  enableAdTextForShares: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  parentClass: PropTypes.string
};

export default injectIntl(FlipboardSocialIcon);
